
import { FaTimes } from "react-icons/fa";
import { Button } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';

const SearchBarButton = ({ brandName, setBrandName, handleSearchClients, handleResetSearch }) => {

  return (  
  <div className="flex flex-row gap-4 items-center justify-center">

    <div className="relative w-full">
      <input
        type="text"
        placeholder="Buscar marca"
        className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
        value={brandName}
        onChange={(e) => setBrandName(e.target.value)}
      />
      {brandName && (
        <FaTimes
          onClick={() => handleResetSearch()}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
        />
      )}
    </div>

    <div>
      <Button 
        variant="contained"
        endIcon={<SearchIcon />}
        sx={{
          fontSize: "12px",
          fontWeight: "bold",
          fontFamily: "poppins",
          padding: "4px 24px",
          backgroundColor: "#ff6400",
          transform: "all",
          animationDuration: "1000",
          textTransform: "none",
          borderRadius: "8px",
          '&:hover': {
            backgroundColor: "#bb4a03",
          }
        }}
        onClick={() => handleSearchClients()}
      >
        Buscar
      </Button>
    </div>

  </div>
  )
}

export default SearchBarButton